'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var basarat = require("../collections");
var collections = basarat.collections;
var PartyNameImpl = (function () {
    function PartyNameImpl() {
    }
    Object.defineProperty(PartyNameImpl.prototype, "shortName", {
        get: function () {
            return this._shortName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PartyNameImpl.prototype, "longName", {
        get: function () {
            return this._longName;
        },
        enumerable: true,
        configurable: true
    });
    PartyNameImpl.prototype.toString = function () {
        return collections.makeString(this);
    };
    return PartyNameImpl;
}());
exports.PartyNameImpl = PartyNameImpl;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImltcGwvUGFydHlOYW1lLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLFlBQVksQ0FBQzs7QUFFYix3Q0FBMkM7QUFDM0MsSUFBTyxXQUFXLEdBQUcsT0FBTyxDQUFDLFdBQVcsQ0FBQztBQVV6QztJQUFBO0lBZ0JBLENBQUM7SUFaQSxzQkFBSSxvQ0FBUzthQUFiO1lBQ0MsT0FBTyxJQUFJLENBQUMsVUFBVSxDQUFDO1FBQ3hCLENBQUM7OztPQUFBO0lBRUQsc0JBQUksbUNBQVE7YUFBWjtZQUNDLE9BQU8sSUFBSSxDQUFDLFNBQVMsQ0FBQztRQUN2QixDQUFDOzs7T0FBQTtJQUVNLGdDQUFRLEdBQWY7UUFFQyxPQUFPLFdBQVcsQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDckMsQ0FBQztJQUNGLG9CQUFDO0FBQUQsQ0FoQkEsQUFnQkMsSUFBQTtBQWhCWSxzQ0FBYSIsImZpbGUiOiJpbXBsL1BhcnR5TmFtZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vLyA8cmVmZXJlbmNlIHBhdGg9XCIuLi9jb2xsZWN0aW9ucy50c1wiIC8+XG5cbid1c2Ugc3RyaWN0JztcblxuaW1wb3J0IGJhc2FyYXQgPSByZXF1aXJlKCcuLi9jb2xsZWN0aW9ucycpO1xuaW1wb3J0IGNvbGxlY3Rpb25zID0gYmFzYXJhdC5jb2xsZWN0aW9ucztcblxuaW1wb3J0IHtQYXJ0eU5hbWV9IGZyb20gXCIuLi9hcGkvUGFydHlOYW1lXCI7XG4vKipcbiAqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKipcbiAqIFJlcHJlc2VudHMgdGhlIG5hbWUgb2YgYW4gUGFydHlcbiAqXG4gKiBAYXV0aG9yICA8YSBocmVmPVwibWFpbHRvOnBoaWxpcHBlLnBhcmF2aWNpbmlAamFudXgub3JnXCI+UGhpbGlwcGUgUGFyYXZpY2luaTwvYT5cbiAqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKipcbiAqL1xuZXhwb3J0IGNsYXNzIFBhcnR5TmFtZUltcGwgaW1wbGVtZW50cyBQYXJ0eU5hbWUge1xuXHRwdWJsaWMgX3Nob3J0TmFtZTpzdHJpbmc7XG5cdHB1YmxpYyBfbG9uZ05hbWU6c3RyaW5nO1xuXG5cdGdldCBzaG9ydE5hbWUoKTpzdHJpbmcge1xuXHRcdHJldHVybiB0aGlzLl9zaG9ydE5hbWU7XG5cdH1cblxuXHRnZXQgbG9uZ05hbWUoKTpzdHJpbmcge1xuXHRcdHJldHVybiB0aGlzLl9sb25nTmFtZTtcblx0fVxuXG5cdHB1YmxpYyB0b1N0cmluZygpOnN0cmluZyB7XG5cdFx0Ly8gU2hvcnQgaGFuZC4gQWRkcyBlYWNoIG93biBwcm9wZXJ0eVxuXHRcdHJldHVybiBjb2xsZWN0aW9ucy5tYWtlU3RyaW5nKHRoaXMpO1xuXHR9XG59IC8vIGVuZCBjbGFzcyBQYXJ0eU5hbWVJbXBsIl0sInNvdXJjZVJvb3QiOiIvc291cmNlLyJ9



//////////////////
// WEBPACK FOOTER
// /var/tomcat/.jenkins/workspace/janux/janux-people/dist/impl/PartyName.js
// module id = rvwP
// module chunks = 0